import React, { useContext, useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';

import { MdArrowBack, MdDelete, MdAddCircle } from 'react-icons/md';
import InputMask from 'react-input-mask';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';

import GlobalContext from '../../../../../context/GlobalContext';

import { DialogBox } from '../../../../components/singleComponents/dialogs/DialogBox';
import { Dropzone } from '../../../../components/singleComponents/dropzone/Dropzone';
import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';

import api, { authHeader } from '../../../../../services/API/apiConfig';
import {
  BtnSubmitStyled,
  CustomSwitchStyled,
  DeleteButtonStyled,
  DivGroupStyled,
  FacadeTitleStyled,
  HeaderPageStyled,
  MainContainerStyled,
  RootStyled,
  SectionTitleStyled,
  ShortInputStyled,
} from './index.styles';

export function FormConstructions() {
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);
  const navigate = useNavigate();
  const match = useMatch('/new-construction/:id');

  const id = match ? match.params.id : null;

  const baseURL = process.env.REACT_APP_API;
  const protocol =
    process.env.REACT_APP_NODE_ENV === 'development' ? 'http' : 'https';

  const [clients, setClients] = useState([]);

  const [name, setName] = useState('');
  const [clientIds, setClientIds] = useState([null]);
  const [description, setDescription] = useState('');
  const [cep, setCep] = useState('');
  const [invalidCep, setInvalidCep] = useState(false);
  const [address, setAddress] = useState('');
  const [address2, setAddress2] = useState('');
  const [addressNum, setAddressNum] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorClientNull, setErrorClientNull] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checked, setChecked] = useState(false);
  const [img, setImg] = useState('');
  const [facadeFile, setFacadeFile] = useState(null);
  const [facade, setFacade] = useState([]);
  const [isUploading, setUploading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  function handleGoBack() {
    navigate(-1);
  }

  const onBlurCep = (ev) => {
    const { value } = ev.target;
    const c = value.replace(/[^0-9]/g, '');

    if (c?.length === 8) {
      fetch(`https://viacep.com.br/ws/${c}/json/`)
        .then((response) => response.json())
        .then((data) => {
          if (data.erro) {
            setInvalidCep(true);
            setCity('');
            setState('');
            setAddress('');
          } else {
            setInvalidCep(false);
            setCep(data.cep);
            setCity(data.localidade);
            setState(data.uf);
            setAddress(data.logradouro);
          }
        });
    } else {
      setInvalidCep(true);
    }
  };

  const onChangeClient = (event, value, index) => {
    const newIds = [...clientIds];
    newIds[index] = value !== null ? value.id : null;
    setClientIds(newIds);
  };

  const addNewClient = () => {
    setClientIds([...clientIds, null]);
  };

  const deleteConstruction = async () => {
    await api
      .delete(`/constructions/${id}`, {
        headers: authHeader(),
      })
      .then(() => {
        setOpenDialog(!openDialog);
        setSuccessMessage('Obra removida com sucesso');
        setSuccessSubmit(true);
        setTimeout(() => {
          setSuccessSubmit(false);
          navigate('/constructions');
        }, 1500);
      });
  };

  const addNewConstruction = () => {
    const validIds = clientIds.filter((clientId) => clientId);
    const uniqueIds = [...new Set(validIds)];

    const data = {
      construction: {
        name,
        user_ids: uniqueIds,
        description,
        zipcode: cep,
        address,
        address_num: addressNum,
        city,
        state,
        address2,
        finished: checked,
      },
    };

    const file = new FormData();
    if (facade.length === 1) {
      file.append('file', facade[0]);
    } else if (img) {
      file.append('file', facadeFile);
    }

    if (id && clientIds !== null && name !== null) {
      api.patch(`/constructions/${id}/facade`, file, {
        headers: {
          ...authHeader(),
          'Content-Type': 'multipart/form-data',
        },
      });

      api
        .patch(`/constructions/${id}`, data, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.data.status === 0) {
            setName(null);
            setAddress(null);
            setAddressNum(null);
            setCity(null);
            setState(null);
            setCep(null);
            setSuccessMessage('Obra editada com sucesso.');
            setSuccessSubmit(true);

            setTimeout(() => {
              handleGoBack();
            }, 2000);
          } else if (res.data.status === 2) {
            setErrorMessage('Erro ao tentar editar a obra');
            setErrorSubmit(true);
          }
        });
    } else if (clientIds !== null && name !== null) {
      if (!clientIds.length) {
        setErrorClientNull(true);
      } else {
        api
          .post('/constructions', data, {
            headers: authHeader(),
          })
          .then((response) => {
            if (response.data.data) {
              api.patch(
                `/constructions/${response.data.data.id}/facade`,
                file,
                {
                  headers: {
                    ...authHeader(),
                    'Content-Type': 'multipart/form-data',
                  },
                }
              );
              setSuccessMessage('Obra cadastrada com sucesso');
              setSuccessSubmit(true);
              setTimeout(() => {
                navigate('/constructions');
                setSuccessSubmit(false);
              }, 1500);
            } else {
              setErrorMessage('Erro ao tentar criar uma nova obra');
              setErrorSubmit(true);
              setTimeout(() => {
                setErrorSubmit(false);
              }, 1500);
            }
          });
      }
    }

    setTimeout(() => {
      setButtonDisabled(false);
    }, 300);
  };

  const removeFacade = () => {
    setImg('');
    setFacade([]);
  };

  useEffect(() => {
    if (id) {
      api
        .get(`/constructions/${id}`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;

          setChecked(data.finished);
          setName(data.name);
          setCep(data.zipcode);
          setAddress(data.address);
          setAddressNum(data.address_num);
          setAddress2(data.address2);
          setCity(data.city);
          setState(data.state);
          setDescription(data.description);

          const usersId = data.users.map((user) => user.id);
          if (usersId.length) {
            setClientIds(usersId);
          }

          if (data.path) {
            setImg(`${protocol}://${subdomain}.${baseURL}${data.path.url}`);
          }
        });
    }
    api
      .get('/users', {
        headers: authHeader(),
      })
      .then((response) => {
        const { data } = response.data;
        setClients(data);
      });
  }, []);

  useEffect(() => {
    if (clientIds.length) setErrorClientNull(false);
  }, [clientIds]);

  return (
    <>
      <RootStyled>
        {successSubmit && <ToasterBox message={successMessage} />}
        {errorSubmit && <ToasterBox message={errorMessage} />}
        <HeaderPageStyled>
          <IconButton onClick={() => handleGoBack()} size="large">
            <MdArrowBack size={25} />
          </IconButton>
          <MainContainerStyled>
            <Typography variant="h1">
              {id ? 'Editar obra' : 'Adicionar obra'}
            </Typography>
            {id && (
              <DeleteButtonStyled onClick={() => setOpenDialog(!openDialog)}>
                <MdDelete className="icon" />
                Remover obra
              </DeleteButtonStyled>
            )}
          </MainContainerStyled>
        </HeaderPageStyled>
        <div>
          <div id="general-info">
            <SectionTitleStyled variant="h3">
              Informações gerais da obra
            </SectionTitleStyled>
            <DivGroupStyled>
              <TextField
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Nome da obra"
                style={{ flex: 1 }}
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </DivGroupStyled>
            <DivGroupStyled>
              <TextField
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Descrição"
                style={{ flex: 1 }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </DivGroupStyled>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }}
            >
              {clientIds.map((clientId, index) => (
                <Autocomplete
                  key={clientId}
                  options={clients}
                  value={
                    clients.find((client) => client.id === clientIds[index]) ||
                    null
                  }
                  onChange={(event, newValue) =>
                    onChangeClient(event, newValue, index)
                  }
                  getOptionLabel={(option) => option.name || ''}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  noOptionsText="Nenhum cliente encontrado"
                  sx={{
                    width: '25%',
                    mr: 2,
                    minWdith: '200px',
                    '.MuiInputBase-input': { height: 23 },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      error={errorClientNull}
                      helperText={
                        errorClientNull
                          ? 'Por favor, identifique o cliente.'
                          : ''
                      }
                      label="Cliente"
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                    />
                  )}
                />
              ))}
              <IconButton color="primary" onClick={addNewClient} size="large">
                <MdAddCircle />
              </IconButton>
            </Box>
          </div>
          <div id="construction-address">
            <SectionTitleStyled>Endereço da obra</SectionTitleStyled>
            <DivGroupStyled>
              <InputMask
                mask="99999-999"
                onBlur={onBlurCep}
                value={cep}
                onChange={(e) => setCep(e.target.value)}
              >
                {() => (
                  <ShortInputStyled
                    error={invalidCep}
                    helperText={invalidCep && 'CEP inválido'}
                    variant="outlined"
                    slotProps={{
                      inputLabel: { shrink: true },
                    }}
                    label="CEP"
                  />
                )}
              </InputMask>
              <TextField
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Endereço"
                style={{ flex: 1 }}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              <TextField
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Número"
                style={{ width: '10%' }}
                value={addressNum}
                onChange={(e) => setAddressNum(e.target.value)}
              />
              <TextField
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Cidade"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </DivGroupStyled>
            <DivGroupStyled>
              <ShortInputStyled
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Estado"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
              <TextField
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                label="Complemento"
                style={{ flex: 1 }}
                value={address2}
                onChange={(e) => setAddress2(e.target.value)}
              />
            </DivGroupStyled>
          </div>
        </div>

        <Grid2
          id="construction-facade"
          container
          justifyContent="space-between"
        >
          <Grid2 item sx={{ width: '80%' }}>
            <Grid2 container spacing={2} direction="column">
              <Grid2 item>
                <FacadeTitleStyled variant="h3">
                  Fachada da obra
                </FacadeTitleStyled>
              </Grid2>
              <Grid2 item>
                <Grid2 container alignItems="center">
                  <Grid2 item sx={{ width: '70%' }}>
                    <Dropzone
                      route=""
                      isFacade
                      setImg={setImg}
                      setUploading={setUploading}
                      setFile={setFacadeFile}
                    />
                  </Grid2>
                  {isUploading && (
                    <Grid2 item>
                      <CircularProgress size={28} />
                    </Grid2>
                  )}
                </Grid2>
              </Grid2>
              <Grid2 item>
                {img ? (
                  <>
                    <img src={img} alt="Fachada da obra" height="200em" />
                    <DeleteButtonStyled onClick={removeFacade}>
                      <MdDelete className="icon" />
                      Remover imagem
                    </DeleteButtonStyled>
                  </>
                ) : (
                  <Typography component="h6" variant="h4">
                    A obra ainda não possui imagem da fachada
                  </Typography>
                )}
              </Grid2>
              <Grid2 item>
                <FormControl>
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      value="start"
                      style={{ display: 'flex', gap: 16 }}
                      control={
                        <Tooltip title={checked ? 'Encerrada' : 'Pendente'}>
                          <CustomSwitchStyled
                            color="secondary"
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                          />
                        </Tooltip>
                      }
                      label="A obra foi encerrada?"
                      labelPlacement="start"
                    />
                  </FormGroup>
                </FormControl>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 item>
            <BtnSubmitStyled
              disabled={buttonDisabled}
              id="form-button"
              variant="contained"
              color="secondary"
              onClick={() => {
                setButtonDisabled(true);
                addNewConstruction();
              }}
            >
              {id ? 'Salvar obra' : 'Cadastrar obra'}
            </BtnSubmitStyled>
          </Grid2>
        </Grid2>
      </RootStyled>

      <DialogBox
        title="Remover obra"
        content="Deseja realmente remover esta obra? Todas as informações inseridas serão perdidas."
        openDialog={openDialog}
        closeDialog={() => setOpenDialog(!openDialog)}
        mainAction={deleteConstruction}
      />
    </>
  );
}
